import store from "@/store/store";
import { LoadersService } from "@/types/services/loaders";

export const loadersService: LoadersService = {
  showGlobal: async () => await store.dispatch("application/showAppLoadingMask"),
  hideGlobal: async () => await store.dispatch("application/hideAppLoadingMask"),
};
